<mat-expansion-panel
    class="w-full"
    [expanded]="true">
    <mat-expansion-panel-header class="!font-semibold !text-base pb-2 !pl-2"
        >{{ 'operator' | transloco: { COUNT: sortedOperatorsByCheck.length } }}
    </mat-expansion-panel-header>
    @for (operator of sortedOperatorsByCheck; track operator.id) {
        <div
            class="pl-0 mb-2 flex align-middle justify-start items-center cursor-pointer"
            [class.option-selected]="filterEntitiesTableService.filterByParams()?.people?.includes(operator.id)"
            (click)="filterEntitiesTableService.toggleSelection(operator.id, 'people')">
            <app-checkbox
                [checkboxState]="
                    filterEntitiesTableService.filterByParams()?.people?.includes(operator.id)
                        ? CheckboxState.CHECKED
                        : CheckboxState.UNCHECKED
                " />

            <div class="flex flex-row justify-center items-center">
                <app-operator-icon
                    class="mx-1"
                    [path]="operator.image"
                    [size]="1" />
                <span class="pl-1 flex-1 overflow-x-hidden text-ellipsis whitespace-nowrap"
                    >{{ operator.givenName }} {{ operator.familyName }}</span
                >
            </div>
        </div>
    } @empty {
        <div class="flex flex-col items-center justify-center h-full text-custom-light-grey">
            <fa-icon
                class="pb-2"
                size="xl"
                [icon]="['fad', 'empty-set']" />

            <span class="!font-normal !text-sm">{{ 'noOperator' | transloco }}</span>
        </div>
    }
    @if (filterEntitiesTableService.operatorsWithPagination()?.hasNextPage) {
        <span
            class="text-custom-dark-grey cursor-pointer hover:underline"
            (click)="
                filterEntitiesTableService.loadOperatorsWithPagination(
                    filterEntitiesTableService.operatorsWithPagination()!.page + 1
                )
            ">
            {{ 'displayMore' | transloco }}
            {{
                `(${
                    filterEntitiesTableService.operatorsWithPagination()!.totalItems -
                    filterEntitiesTableService.operatorsWithPagination()!.items.length
                })`
            }}
            <fa-icon [icon]="['fas', 'chevron-down']" />
        </span>
    } @else if (filterEntitiesTableService.operatorsWithPagination()?.hasPreviousPage) {
        <span
            class="text-custom-dark-grey cursor-pointer hover:underline"
            (click)="filterEntitiesTableService.loadOperatorsWithPagination(0)">
            {{ 'displayLess' | transloco }}

            <fa-icon
                [icon]="['fas', 'chevron-down']"
                [rotate]="180" />
        </span>
    }
</mat-expansion-panel>
